<template>
  <div>
    <div class="tab-competences" :class="{'has-ai': competencesAi.length > 0}" id="tab-competences">
      <div v-if="disallowed" class="forbidden">{{ $tr('common.forbidden') }}</div>
      <div v-if="!disallowed">
        <div v-if="competences.length > 0" :class="{'has-hint': hasCompetenceHint}">
          <div class="competences-title competences-ai-title" v-if="competencesAi && competencesAi.length > 0">
            <img :src="currentUser.logo || '/static/images/elements/man.png'" class="competence-avatar"/>
            <span>{{$tr('response.competence.choice')}}</span>
          </div>
          <div class="answers">
            <div v-for="competence in competences" :key="competence.id" class="answer-block">
              <div class="row-block designation">
                <div class="subtitle-container">
                  <div class="subtitle">{{ competence.name }}</div>
                </div>
                <div class="answer-rating-container">
                  <div class="answer-rating">
                  <span
                    class="answer-rating__inner answer-rating__inner_selectable"
                    :class="getCompetenceValueColor(i, competence.value, competence.level.max_value)"
                    v-for="(_, i) in [...new Array(competence.level.max_value)]"
                    :key="`${competence.id}_${i}`"
                  >
                    <div class="competences-icon" :class="{'competences-icon--star': ratingViewType !== 'Circle'}"
                      @click="change_competence(competence, i + 1)">
                      <svg v-show="ratingViewType !== 'Circle'" width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.9762 16.84L16.0508 19.9092C16.9802 20.4717 18.1174 19.6402 17.8728 18.5886L16.5277 12.8169L21.0154 8.92841C21.8347 8.21918 21.3945 6.8741 20.3184 6.7885L14.4123 6.28715L12.1012 0.833431C11.6854 -0.157042 10.267 -0.157042 9.85122 0.833431L7.54011 6.27492L1.63396 6.77627C0.557887 6.86187 0.117677 8.20696 0.936957 8.91618L5.42466 12.8047L4.07957 18.5764C3.83501 19.628 4.97222 20.4595 5.90155 19.897L10.9762 16.84Z" fill="currentColor"/>
                      </svg>
                    </div>
                  </span>
                  </div>
                </div>
                <div v-if="competence.hint" v-tooltip.left-start="getHintSettings(competence)"
                    class="info-block">
                  <img src="/static/icons/info.svg" alt="Help">
                </div>
              </div>
            </div>
          </div>

          <div class="block-overall-rating">
            <div class="row-block">
              <div class="text-overall-rating-wrapper">
                <div class="text-overall-rating">{{ $tr('responses.tabs.competences.rating') }}</div>
                <div class="text-overall-rating-container">
                  <div class="answer-rating">
                    <span
                      class="answer-rating__inner"
                      :class="getValueColor(curIndex, overallRating, maxLevel)"
                      v-for="(_, curIndex) in [...new Array(maxLevel)]"
                      :key="curIndex"
                    >
                      <div class="competences-icon" :class="{'competences-icon--star': ratingViewType !== 'Circle'}">
                        <svg v-show="ratingViewType !== 'Circle'" width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.9762 16.84L16.0508 19.9092C16.9802 20.4717 18.1174 19.6402 17.8728 18.5886L16.5277 12.8169L21.0154 8.92841C21.8347 8.21918 21.3945 6.8741 20.3184 6.7885L14.4123 6.28715L12.1012 0.833431C11.6854 -0.157042 10.267 -0.157042 9.85122 0.833431L7.54011 6.27492L1.63396 6.77627C0.557887 6.86187 0.117677 8.20696 0.936957 8.91618L5.42466 12.8047L4.07957 18.5764C3.83501 19.628 4.97222 20.4595 5.90155 19.897L10.9762 16.84Z" fill="currentColor"/>
                        </svg>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row-block" v-if="allOverallRating !== null">
              <div class="text-overall-rating-wrapper">
                <div class="text-overall-rating">{{ $tr('responses.tabs.competences.ratingAll') }}</div>
                <div class="text-overall-rating-container">
                  <div class="answer-rating">
                    <span
                      class="answer-rating__inner"
                      :class="getValueColor(curIndex, allOverallRating, maxLevel)"
                      v-for="(_, curIndex) in maxLevel"
                      :key="curIndex"
                    >
                      <div class="competences-icon" :class="{'competences-icon--star': ratingViewType !== 'Circle'}">
                        <svg v-show="ratingViewType !== 'Circle'" width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M10.9762 16.84L16.0508 19.9092C16.9802 20.4717 18.1174 19.6402 17.8728 18.5886L16.5277 12.8169L21.0154 8.92841C21.8347 8.21918 21.3945 6.8741 20.3184 6.7885L14.4123 6.28715L12.1012 0.833431C11.6854 -0.157042 10.267 -0.157042 9.85122 0.833431L7.54011 6.27492L1.63396 6.77627C0.557887 6.86187 0.117677 8.20696 0.936957 8.91618L5.42466 12.8047L4.07957 18.5764C3.83501 19.628 4.97222 20.4595 5.90155 19.897L10.9762 16.84Z" fill="currentColor"/>
                        </svg>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="no-competences">
          <div class="message"> {{ $tr('responses.tabs.competences.noCompetences') }}</div>
        </div>
      </div>
    </div>

    <div class="tab-competences-ai" id="tab-competences-ai" v-if="competencesAi.length > 0">
      <div class="competences-ai-title">
        <img src="/static/images/elements/competence-icon.svg">
        <span v-if="!competencesAiUserValues || !competencesAiUserValues.length">{{$tr('response.competence.competenceAI.titleFirst')}} {{$tr('response.competence.competenceAI.titleSecond')}}</span>
        <span v-if="competencesAiUserValues && competencesAiUserValues.length">{{$tr('response.competence.competenceAI.titleThird')}}&nbsp;</span>
        <span @click="toggleUserValues(false)" class="competences-ai-title__bold" v-if="competencesAiUserValues && competencesAiUserValues.length && showAiUserValues">{{$tr('response.competence.competenceAI.showMarks')}}</span>
        <span @click="toggleUserValues(true)" class="competences-ai-title__bold" v-if="competencesAiUserValues && competencesAiUserValues.length && !showAiUserValues">{{$tr('response.competence.competenceAI.hideMarks')}}</span>
      </div>
      <div v-if="!disallowedAi">
        <div v-if="competencesAi.length > 0">
          <div class="answers">
            <div v-for="competence in competencesAi" :key="competence.ai_competence_id" class="answer-block">
              <div class="row-block designation">
                <div class="subtitle-container">
                  <div class="subtitle">{{ $tr('response.competence.code.' + competence.code) }}</div>
                </div>
                <div class="answer-rating-container">
                  <div class="answer-rating answer-rating__hidden" :class="{'is-visible': !showAiUserValues || !competenceValueFromId(competence.ai_competence_id)}">
                    <span
                      class="answer-rating__inner answer-rating__inner-small answer-rating__inner_selectable"
                      :class="getCompetenceValueColor(i, competence.value, competence.max_value)"
                      v-for="(_, i) in [...new Array(competence.max_value)]"
                      :key="`${competence.ai_competence_id}_${i}`"
                    >
                      <div
                        class="rating-item rating-item__small"
                        @click="changeCompetenceAiUserValues(competence, i + 1)"
                      ></div>
                    </span>
                  </div>
                  <div class="answer-rating answer-rating__hidden" :class="{'is-visible': showAiUserValues && competenceValueFromId(competence.ai_competence_id)}">
                    <span
                      class="answer-rating__inner answer-rating__inner-small answer-rating__inner_selectable"
                      :class="getCompetenceAIValueColor(i, competence.ai_competence_id, competence.max_value)"
                      v-for="(_, i) in [...new Array(competence.max_value)]"
                      :key="`${competence.ai_competence_id}_${i}`"
                    >
                      <div
                        class="rating-item rating-item__small"
                        @click="changeCompetenceAiUserValues(competence, i + 1)"
                      ></div>
                    </span>
                  </div>
                </div>
                <div v-if="competence.hint" v-tooltip.left-start="getHintSettings(competence)"
                    class="info-block">
                  <img src="/static/icons/info.svg" alt="Help">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tab-competences',

    props: {
      responseId: String
    },

    data() {
      return {
        choseAiUserValues: null
      }
    },

    methods: {
      change_competence (competence, value) {
        if (competence.value !== value) {
          this.updateCompetence(competence, value)
        } else {
          this.deleteCompetence(competence, value)
        }
      },

      competenceValueFromId(id) {
        if (!this.competencesAiUserValues || !this.competencesAiUserValues.length) {
          return null;
        }
        return this.competencesAiUserValues.find(item => item.ai_competence_id === id);
      },

      changeCompetenceAiUserValues (competence, value) {
        this.updateCompetenceAiUserValues(competence, value)
      },

      toggleUserValues(val) {
        this.showAiUserValues = val;
      },

      getHintSettings(competence) {
        const breakSigns = /(\r\n|\n|\r)/gm

        return {
          content: competence.hint.replace(breakSigns, '<br>'),
          classes: ['competence-helper']
        }
      },

      deleteCompetence (competence, value) {
        this.$store.dispatch('response/deleteCompetences', {
          id: this.responseId,
          competences: [{id: competence.id, value}]
        }).then(() => this.fetchCompetences())
      },

      updateCompetence (competence, value) {
        this.$store.dispatch('response/updateCompetences', {
          id: this.responseId,
          competences: [{id: competence.id, value}]
        })
        .then(() => {
          if (window.gtag) {
            window.gtag({'event': 'response_competence_evaluation'});
          }
        })
      },

      updateCompetenceAiUserValues (competence, value) {
        this.$store.dispatch('response/updateCompetencesAiUserValues', {
          id: this.responseId,
          competences: [{ai_competence_id: competence.ai_competence_id, value}]
        })
        .then(() => {
          this.fetchCompetencesAiUserValues();
          this.showAiUserValues = true;
        })
      },

      // updateCompetenceAiUserValues (competence, value) {
      //   this.$store.dispatch('response/updateCompetencesAiUserValues', {
      //     id: this.responseId,
      //     competences: [{id: competence.id, value}]
      //   })
      // },

      fetchCompetences() {
        this.$store.dispatch('response/fetchCompetences', this.responseId)
      },

      fetchCompetencesAi() {
        this.$store.dispatch('response/fetchCompetencesAi', this.responseId)
      },

      fetchCompetencesAiUserValues() {
        this.$store.dispatch('response/fetchCompetencesAiUserValues', this.responseId)
      },

      getValueColor (curIndex, value, maxValue) {
        if (curIndex + 1 > value) return ''

        if (Math.ceil(value) === 1) return 'red'
        if (Math.ceil(value) === maxValue) return 'green'

        return 'yellow'
      },

      getCompetenceValueColor (curIndex, value, maxValue) {
        if (curIndex + 1 > value) return 'empty'

        let color = '';

        if (Math.ceil(value) === 1) {
          color = 'red';
        } else if (Math.ceil(value) === maxValue) {
          color = 'green';
        } else {
          color = 'yellow';
        }

        if (value <= curIndex) {
          return ' empty';
        } else {
          return color;
        }
      },

      getCompetenceAIValueColor (curIndex, id, maxValue) {
        const compenenceAi = this.competenceValueFromId(id);
        if (!compenenceAi) {
          return 'empty';
        }

        return this.getCompetenceValueColor(curIndex, compenenceAi.value, maxValue);
      },

      ratingItemView (isMore) {
        if (this.ratingViewType !== 'Circle') {
          if (isMore) {
            return 'fa-star'
          } else {
            return 'fa-star'
          }
        } else {
          if (isMore) {
            return 'fa-circle'
          } else {
            return 'fa-circle'
          }
        }
      }
    },

    computed: {
      currentUser () {
        return this.$store.getters['user/current'] || {}
      },

      disallowed () {
        return this.$store.state.response.competencesDisallow
      },

      disallowedAi () {
        return this.$store.state.response.competencesAiDisallow
      },

      competences () {
        return this.$store.getters['response/competences'] || []
      },

      hasCompetenceHint() {
        if (!this.competences || !this.competences.length) {
          return false;
        }

        return this.competences.some(competence => !!competence.hint)
      },

      competencesAi () {
        return this.$store.getters['response/competencesAi'] || []
      },

      competencesAiUserValues () {
        return this.$store.getters['response/competencesAiUserValues'] || []
      },

      showAiUserValues: {
        get() {
          if (this.choseAiUserValues === null) {
            return !!this.competencesAiUserValues && this.competencesAiUserValues.length;
          }

          return this.choseAiUserValues;
        },

        set(val) {
          this.choseAiUserValues = val;
        }
      },

      overallRating () {
        return Math.round(this.$store.getters['response/overallRating']) || 0
      },

      allOverallRating () {
        const rating = this.$store.getters['response/allOverallRating'];

        if (rating === null) {
          return null
        }

        return Math.round(rating) || 0
      },

      maxLevel () {
        return this.competences[0] ? this.competences[0].level.max_value : 5
      },

      ratingViewType () {
        return this.$store.getters['response/competences'][0].view.name || ''
      }
    },

    created() {
      this.$store.dispatch('response/fetchCompetences', this.responseId)
      this.$store.dispatch('response/fetchCompetencesAi', this.responseId)
      this.$store.dispatch('response/fetchCompetencesAiUserValues', this.responseId)
    },
  }
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';
@import '@/styles/variables.scss';

.tab-competences {
  .forbidden {
    margin-top: 20px;
    margin-right: 15px;
  }
}

.answer-block .title {
  margin-left: 16px;
  margin-top: 20px;
  margin-bottom: 33px;
  color: $green;
  font-size: 18px;
}

.answer-block .designation {
  margin-top: 16px;
  display: flex;
  position: relative;
}

.tab-competences-ai {
  .answer-block .designation {
    margin-top: 26px;
  }
}

.subtitle-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 292px;
  margin-right: 24px;
}

.answer-block .designation .subtitle {
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.005em;
  color: #233346;
  margin-left: 0;
}

.answer-rating {
  display: flex;
  position: relative;

  &.answer-rating__hidden {
    visibility: hidden;
    height: 0;
    margin: 0;
    padding: 0;
    opacity: 0;
    transition: opacity 0.4s;
    z-index: -1;

    &.is-visible {
      visibility: visible;
      height: auto;
      opacity: 1;
      transition: opacity 0.4s;
      z-index: 1;
    }
  }
}

.answer-rating__inner {
  margin-right: 2px;

  &.answer-rating__inner-small {
    margin-right: 10px;
  }
}

.answer-rating__inner_selectable {
  cursor: pointer;
}

.rating__item {
  transition: all 0.7s;
}

.rating__item_non-selected {
  opacity: 0.6;
}

.rating__item_selected {
  opacity: 1;
}

.answer-rating__inner:last-child {
  margin-right: 0;
}

.answer-rating {
  span {
    color: #d2d6e0 !important;
    background-color: transparent !important;
    border-color: transparent !important;
    font-size: 15px;
    width: 20px;
    height: 20px;
    margin-right: 10px;
    line-height: 20px;
    // margin-top: -3px;
    &.red {
      color: $red-color !important;
    }
    &.green {
      color: $green !important;
    }
    &.yellow {
      color: $yellow-color !important;
    }
    &.empty {
      color: #d2d6e0 !important;
    }
  }

  span.answer-rating__inner-small {
    width: 20px;
    height: 20px;
  }
}

.rating-item {
  display: block;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: transparent;

  &.rating-item__small {
    width: 20px;
    height: 20px;
  }
}

.red {
  .rating-item {
    background: $red-color;
  }
}

.green {
  .rating-item {
    background: $green;
  }
}

.yellow {
  .rating-item {
    background: $yellow-color;
  }
}

.empty {
  .rating-item {
    background: #d2d6e0;
  }

  &:hover {
    .rating-item {
      background: #9faab6;
    }
  }
}

.answers {
  .answer-rating {
    span {
      &:hover {
        color: #9faab6 !important;
      }
    }

    .rating-item {
      &:hover {
        background: #9faab6 !important;
      }
    }
  }

  .row-block {
    justify-content: flex-start;
    align-items: flex-start;
  }
}

.block-overall-rating {
  .row-block {
    justify-content: flex-start;
  }
}

.text-overall-rating {
  margin-right: 24px;
  display: inline-block;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  width: 292px;
}

.text-overall-rating-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  margin-top: 13px;
}

.no-competences {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.no-competences .message {
  color: $green !important;
  margin-top: 30px;
  margin-bottom: 30px;
}

.fa-star-o {
  color: #999999 !important;
}

.info-block {
  margin-left: 10px;
}

.competences-ai-title {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  color: #607183;

  img {
    margin-right: 10px;
  }

  &.competences-title {
    margin-bottom: -10px;
  }
}

.competences-ai-title__bold {
  font-weight: 500;
  cursor: pointer;

  &:hover {
    color: $green;
  }
}

.tab-competences {
  margin-top: 30px;
  padding-bottom: 32px;
  margin-bottom: 27px;

  &.has-ai {
    border-bottom: 1px solid #d2d6e0;
  }
}

.competence-avatar {
  width: 30px;
  height: 30px;
  border: 1px solid rgba(204, 204, 204, 0.5);
  box-sizing: border-box;
  border-radius: 30px;
  margin-right: 10px;
}

.answer-rating-container {
  margin-left: 0;
}

.has-hint {
  .answer-rating-container,
  .text-overall-rating-container {
    margin-right: 0;
  }
}

.competences-icon {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: currentColor;

  &.competences-icon--star {
    background: transparent;
    color: currentColor;
  }
}
</style>

<style lang="scss">
.tooltip.competence-helper {
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  width: 250px;

  .tooltip-inner {
    background: #ffffff;
    color: #233346;
    // font-family: Roboto, sans-serif;
  }
}
</style>
